module.exports = __webpack_public_path__ + "img/39.8e3c90c0.jpg";